import { Modal, Skeleton } from "antd";
import React, { useCallback, useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { useParams } from "react-router-dom";
import { useFetchTeamGroups, useFetchVenues } from "../../entities/api";
import { useHttp } from "../../hooks/useHttp";
import AddAndEditTeamForm from "./AddAndEditTeamForm";

const AddAndEditTeamModal = ({
  entityId = null,
  entityTarget = "organization",
  handleCloseModal,
  handleSendRequest,
  okButtonLoading,
  openModal,
}) => {
  const { formatMessage } = useIntl();
  const { sport, organizationId, seasonId } = useParams();
  const { loading, request, error, cleanError } = useHttp();
  const [team, setTeam] = useState(null);
  const [formRef, setFormRef] = useState(null);
  const { data: venueList } = useFetchVenues({
    limit: 1000,
  });
  const { data: entityGroupList } = useFetchTeamGroups({
    limit: 1000,
  });

  const handleSetFormRef = (form) => setFormRef(form);

  const fetchTeam = useCallback(async () => {
    try {
      let fetchEntityUrl = `/v1/${sport}/o/${organizationId}/entities/${entityId}`;
      if (entityTarget === "season") {
        fetchEntityUrl = `/v1/${sport}/o/${organizationId}/seasons/${seasonId}/entities/${entityId}`;
      }

      const res = await request({
        url: fetchEntityUrl,
      });
      setTeam(res?.data?.[0] || null);
    } catch (e) {
      console.error(e);
    }
  }, [entityId, organizationId, seasonId, sport]);

  useEffect(() => {
    if (entityId) {
      fetchTeam();
    }
  }, [fetchTeam, entityId]);

  return (
    <Modal
      open={openModal}
      closable={true}
      destroyOnClose={true}
      onCancel={handleCloseModal}
      title={formatMessage({
        id: !entityId ? "team.add" : "team.update",
      })}
      okText={formatMessage({
        id: !entityId ? "add" : "update",
      })}
      onOk={() => handleSendRequest(formRef)}
      okButtonProps={{ loading: okButtonLoading }}
    >
      {!entityId ? (
        <AddAndEditTeamForm
          entityGroupList={entityGroupList}
          handleSetFormRef={handleSetFormRef}
          venueList={venueList}
        />
      ) : team ? (
        <AddAndEditTeamForm
          entityGroupList={entityGroupList}
          handleSetFormRef={handleSetFormRef}
          team={team}
          venueList={venueList}
        />
      ) : (
        <Skeleton />
      )}
    </Modal>
  );
};

export default AddAndEditTeamModal;
